<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="item-container">
      <div class="item-row">
        <vs-input v-model="item.input1" placeholder="Header" />
        <vs-input v-model="item.input2" placeholder="Value" />
        <vs-button @click="removeItem(index)" icon="close" circle></vs-button>
      </div>
    </div>
    <vs-button @click="addItem" icon="add" type="border">Add Header</vs-button>
  </div>
</template>

<script>
export default {
  name: 'ExpandableList',
  props: {
    initialItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: this.initialItems.length ?
        this.initialItems.map(item => ({ ...item })) :
        [{ input1: '', input2: '' }]
    }
  },
  methods: {
    removeItem(index) {
      this.items.splice(index,1)
    },
    getValue() {
      const result = {};
      this.items.forEach(item => {
        if (item.input1 && item.input1.trim() !== '') {
          result[item.input1] = item.input2;
        }
      });
      return JSON.stringify(result);
    },
    addItem() {
      this.items.push({
        input1: '',
        input2: '',
        expanded: false
      })
    },
    setHeaders(jsonString) {
      if (!jsonString || jsonString.trim() === '') {
        return [{ input1: '', input2: '' }];
      }

      try
      {
        const jsonObject = JSON.parse(jsonString);
        if (Object.keys(jsonObject).length === 0) {
          return [{ input1: '', input2: '' }];
        }

        this.items = Object.entries(jsonObject).map(([key, value]) => ({
          input1: key,
          input2: value
           }));
      }
      catch (error) {
        this.items = [{ input1: '', input2: '' }];
      }
    },
    clearHeaders() {
      this.items = this.initialItems.length ?
        this.initialItems.map(item => ({ ...item })) :
        [{ input1: '', input2: '' }]
    }
  }
}
</script>

<style scoped>
  .item-container {
    margin-bottom: 10px;
  }

  .item-row {
    display: flex;
    gap: 10px;
    align-items: center;
  }
</style>
